import axios_instance from "./index"
import urls from "./urls"

function getCookie(key) {
    //以分号分割cookie并返回一个数组
    var res = document.cookie.split(";");
    if (res) {
        for (let i = 0; i < res.length; i++) {
            var temp = res[i].split("=");
            if (temp[0].trim() === key) {
                return temp[1]
            }
        }
    }
}

function appendFormData(formData, key, value) {

    if (formData && key && value) {
        formData.append(key, value)
    }
}

const xsrf_key = "_xsrf"

export default {
    site_user: {
        wx_login(appid, url) {
            let redirect_uri = encodeURIComponent(url)
            window.location.href = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appid + "&redirect_uri=" + redirect_uri + "&response_type=code&scope=snsapi_userinfo&state=STATE"
        },
        login(
            username,
            password
        ) {
            var formData = new FormData()
            if (username) {
                appendFormData(formData, "username", username)
            }
            if (password) {
                appendFormData(formData, "password", password)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.user.login, formData)
        },
        register(
            username,
            email,
            password,
            repassword
        ) {
            var formData = new FormData()
            if (username) {
                appendFormData(formData, "username", username)
            }
            if (email) {
                appendFormData(formData, "email", email)
            }
            if (password) {
                appendFormData(formData, "password", password)
            }
            if (repassword) {
                appendFormData(formData, "repassword", repassword)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.user.register, formData)
        },
        bind(
            username,
            email,
            password,
            repassword,
            is_login,
        ) {

            var formData = new FormData()
            if (username) {
                appendFormData(formData, "username", username)
            }
            if (email) {
                appendFormData(formData, "email", email)
            }
            if (password) {
                appendFormData(formData, "password", password)
            }
            if (repassword) {
                appendFormData(formData, "repassword", repassword)
            }
            if (is_login != undefined && is_login != null) {
                appendFormData(formData, "is_login", is_login)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.user.bind, formData)
        },
        unbind(
            password,
        ) {
            var formData = new FormData()
            if (password) {
                appendFormData(formData, "password", password)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.user.unbind, formData)
        },
        reset_password(
            validation_token,
            password,
            repassword
        ) {
            var formData = new FormData()
            if (validation_token) {
                appendFormData(formData, "validation_token", validation_token)
            }
            if (password) {
                appendFormData(formData, "password", password)
            }
            if (repassword) {
                appendFormData(formData, "repassword", repassword)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.user.reset_password, formData)
        },
        forget_password(
            email
        ) {
            var formData = new FormData()
            if (email) {
                appendFormData(formData, "email", email)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }

            return axios_instance.post(urls.user.forget_password, formData)
        },
        userinfo() {
            return axios_instance.get(urls.user.userinfo)
        },
        update(
            date_of_birth,
            email,
            mobile,
            username,
            nickname,
            name,
            sex,
            age,
            avatar,
            password,
            sign,
            appraisal_certificate_images = [],
        ) {
            var formData = new FormData()

            if (date_of_birth) {
                appendFormData(formData, "date_of_birth", date_of_birth)
            }
            if (email) {
                appendFormData(formData, "email", email)
            }
            if (mobile) {
                appendFormData(formData, "mobile", mobile)
            }
            if (username) {
                appendFormData(formData, "username", username)
            }
            if (nickname) {
                appendFormData(formData, "nickname", nickname)
            }
            if (name) {
                appendFormData(formData, "name", name)
            }
            if (sex) {
                appendFormData(formData, "sex", sex)
            }
            if (age) {
                appendFormData(formData, "age", age)
            }
            if (password) {
                appendFormData(formData, "password", password)
            }
            if (sign) {
                appendFormData(formData, "sign", sign)
            }
            try {
                if (avatar) {
                    var avatarObj = avatar.originFileObj
                    console.log(avatar.url)
                    if (avatarObj || avatar.url) {
                        if (!avatarObj) {
                            avatarObj = avatar.url
                        }
                        appendFormData(formData, "avatar", avatarObj)
                    }
                }
            } finally {
                console.log()
            }


            var appraisal_certificate_image_dict = {}
            var fileObj = undefined
            if (appraisal_certificate_images) {
                for (var index = 0; index < appraisal_certificate_images.length; index++) {
                    appraisal_certificate_image_dict = appraisal_certificate_images[index]
                    try {
                        fileObj = appraisal_certificate_image_dict.originFileObj
                        if (fileObj) {
                            appendFormData(formData, "appraisal_certificate_" + String(index), fileObj)
                        } else {
                            fileObj = appraisal_certificate_image_dict.url
                            appendFormData(formData, "appraisal_certificate_" + String(index), fileObj)
                        }
                    } finally {
                        console.log()
                    }
                }
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.user.update, formData)
        }
    },
    order: {
        menu_price_list() {
            var formData = new FormData()
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.menu_price_list, formData)
        },
        pre_create(
            covers,
            license_plate,
            vin_no,
            model,
            meter_mileage,
            displacement,
            displacement_unit,
            customer_name,
            customer_mobile,
            customer_idcard_no,
            remark,
            mode,
            use_user_info = true,
        ) {
            var formData = new FormData()
            var cover_dict = {}
            var fileObj = undefined
            if (covers) {
                for (var index = 0; index < covers.length; index++) {
                    cover_dict = covers[index]
                    fileObj = cover_dict.originFileObj
                    if (!fileObj) {
                        fileObj = cover_dict.url
                    }

                    appendFormData(formData, "cover_" + String(index), fileObj)
                }
            }

            if (license_plate) {
                appendFormData(formData, "license_plate", license_plate)
            }
            if (vin_no) {
                appendFormData(formData, "vin_no", vin_no)
            }
            if (model) {
                appendFormData(formData, "model", model)
            }

            var meter_mileage_value = meter_mileage
            if (parseFloat(meter_mileage) == isNaN) {
                meter_mileage_value = 0
            } else {
                if (meter_mileage != "" && meter_mileage != null && meter_mileage != undefined && parseFloat(meter_mileage) >= 0) {
                    meter_mileage_value = parseFloat(meter_mileage)
                }
            }
            console.log(meter_mileage_value)
            appendFormData(formData, "meter_mileage", meter_mileage_value)

            if (displacement) {
                appendFormData(formData, "displacement", displacement)
            }
            if (displacement) {
                appendFormData(formData, "displacement_unit", displacement_unit)
            }
            if (customer_name) {
                appendFormData(formData, "customer_name", customer_name)
            }
            if (customer_mobile) {
                appendFormData(formData, "customer_mobile", customer_mobile)
            }
            if (customer_idcard_no) {
                appendFormData(formData, "customer_idcard_no", customer_idcard_no)
            }
            if (remark) {
                appendFormData(formData, "remark", remark)
            }
            if (mode) {
                appendFormData(formData, "mode", mode)
            }
            if (use_user_info) {
                appendFormData(formData, "use_user_info", use_user_info)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.pre_create, formData)
        },
        create(
            covers,
            license_plate,
            vin_no,
            model,
            meter_mileage,
            displacement,
            displacement_unit,
            customer_name,
            customer_mobile,
            customer_idcard_no,
            remark,
            mode,
        ) {
            var formData = new FormData()
            var cover_dict = {}
            var fileObj = undefined
            if (covers) {
                for (var index = 0; index < covers.length; index++) {
                    cover_dict = covers[index]
                    fileObj = cover_dict.originFileObj
                    if (!fileObj) {
                        fileObj = cover_dict.url
                    }

                    appendFormData(formData, "cover_" + String(index), fileObj)
                }
            }

            if (license_plate) {
                appendFormData(formData, "license_plate", license_plate)
            }
            if (vin_no) {
                appendFormData(formData, "vin_no", vin_no)
            }
            if (model) {
                appendFormData(formData, "model", model)
            }

            var meter_mileage_value = meter_mileage
            if (parseFloat(meter_mileage) == isNaN) {
                meter_mileage_value = 0
            } else {
                if (meter_mileage != "" && meter_mileage != null && meter_mileage != undefined && parseFloat(meter_mileage) >= 0) {
                    meter_mileage_value = parseFloat(meter_mileage)
                }
            }
            console.log(meter_mileage_value)
            appendFormData(formData, "meter_mileage", meter_mileage_value)

            if (displacement) {
                appendFormData(formData, "displacement", displacement)
            }
            if (displacement) {
                appendFormData(formData, "displacement_unit", displacement_unit)
            }
            if (customer_name) {
                appendFormData(formData, "customer_name", customer_name)
            }
            if (customer_mobile) {
                appendFormData(formData, "customer_mobile", customer_mobile)
            }
            if (customer_idcard_no) {
                appendFormData(formData, "customer_idcard_no", customer_idcard_no)
            }
            if (remark) {
                appendFormData(formData, "remark", remark)
            }
            if (mode) {
                appendFormData(formData, "mode", mode)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.create, formData)
        },
        delete(
            order_id,
        ) {
            var formData = new FormData()
            if (order_id) {
                appendFormData(formData, "identifier", order_id)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.delete, formData)
        },
        list(
            page,
            page_count,
            order,
        ) {
            var formData = new FormData()
            if (page) {
                appendFormData(formData, "page", page)
            }
            if (page_count) {
                appendFormData(formData, "page_count", page_count)
            }
            if (order) {
                appendFormData(formData, "order", order)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.list, formData)
        },
        export_order_detail(
            identifier,
        ) {
            
            var formData = new FormData()
            if (identifier) {
                appendFormData(formData, "order_id", identifier)
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.export_order, formData)
        },
        detail(
            identifier,
            anonymous = false
        ) {
            var formData = new FormData()
            if (identifier) {
                appendFormData(formData, "identifier", identifier)
            }

            if (anonymous) {
                appendFormData(formData, "anonymous", anonymous)
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.detail, formData)
        },
        report_order_detail(
            identifier,
            anonymous = false
        ) {
            var formData = new FormData()
            if (identifier) {
                appendFormData(formData, "order_id", identifier)
            }

            if (anonymous) {
                appendFormData(formData, "anonymous", anonymous)
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.report_order_detail, formData)
        },
        fetch_report_edit(
            identifier,
            anonymous = false
        ) {
            var formData = new FormData()
            if (identifier) {
                appendFormData(formData, "order_id", identifier)
            }

            if (anonymous) {
                appendFormData(formData, "anonymous", anonymous)
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.fetch_report_edit, formData)
        },
        update(
            order,
            registration,
            registration_address
        ) {
            var formData = new FormData()

            if (order) {
                appendFormData(formData, "identifier", order.identifier)

                if (order.menu) {
                    appendFormData(formData, "mode", order.menu.mode)
                }
                
                if (order.auto) {
                    appendFormData(formData, "license_plate", order.auto.license_plate)
                    appendFormData(formData, "vin_no", order.auto.vin_no)

                    var meter_mileage_value = order.auto.meter_mileage
                    var meter_mileage = order.auto.meter_mileage
                    if (parseFloat(meter_mileage) == isNaN) {
                        meter_mileage_value = 0
                    } else {
                        if (meter_mileage && parseFloat(meter_mileage) >= 0) {
                            meter_mileage_value = parseFloat(meter_mileage)
                        }
                    }
                    appendFormData(formData, "meter_mileage", meter_mileage_value)

                    appendFormData(formData, "displacement", order.auto.displacement)

                    appendFormData(formData, "displacement_unit", order.auto.displacement_unit)

                    appendFormData(formData, "remark", order.auto.remark)

                    appendFormData(formData, "model", order.auto.model)
                    appendFormData(formData, "vehicle_color", order.auto.vehicle_color)
                    appendFormData(formData, "gearbox_type", order.auto.gearbox_type)
                    appendFormData(formData, "maintenance_status", order.auto.maintenance_status)
                    appendFormData(formData, "annual_inspection_expiration", order.auto.annual_inspection_expiration)
                    appendFormData(formData, "strong_insurance_expiry", order.auto.strong_insurance_expiry)
                    appendFormData(formData, "engine_no", order.auto.engine_no)
                    appendFormData(formData, "vehicle_source", order.auto.vehicle_source)
                    appendFormData(formData, "amount_of_protection_number", order.auto.amount_of_protection_number)
                    appendFormData(formData, "amount_of_protection_zh", order.auto.amount_of_protection_zh)
                    appendFormData(formData, "nature_of_use", order.auto.nature_of_use)
                    appendFormData(formData, "first_boarding_date", order.auto.first_boarding_date)
                }

                if (order.customer) {
                    appendFormData(formData, "customer_name", order.customer.name)
                    appendFormData(formData, "customer_mobile", order.customer.mobile)
                    appendFormData(formData, "customer_idcard_no", order.customer.idcard_no)
                }
            }
            if (registration_address) {
                appendFormData(formData, "registration_address", registration_address)
            }
            if (registration && registration.length == 3) {
                appendFormData(formData, "registration_province", registration[0])
                appendFormData(formData, "registration_city", registration[1])
                appendFormData(formData, "registration_district", registration[2])
            }

            appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            return axios_instance.post(urls.order.update, formData)
        },
        commit(
            order_id,
            maintenance_recommendations
        ) {
            var formData = new FormData()
            if (order_id) {
                appendFormData(formData, "identifier", order_id)
            }
            if (maintenance_recommendations) {
                appendFormData(formData, "maintenance_recommendations", maintenance_recommendations)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.commit, formData)
        },
        asign_inspector(
            order,
            inspector_id
        ) {
            var formData = new FormData()
            if (order && order.identifier) {
                appendFormData(formData, "identifier", order.identifier)
            }
            if (inspector_id) {
                appendFormData(formData, "inspector_id", inspector_id)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.asign_inspector, formData)
        },

        customer_detail(
            identifier,
            anonymous = false
        ) {
            var formData = new FormData()
            if (identifier) {
                appendFormData(formData, "customer_id", identifier)
            }

            if (anonymous) {
                appendFormData(formData, "anonymous", anonymous)
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.customer_detail, formData)
        },

        auto_detail(
            identifier,
            anonymous = false
        ) {
            var formData = new FormData()
            if (identifier) {
                appendFormData(formData, "auto_id", identifier)
            }

            if (anonymous) {
                appendFormData(formData, "anonymous", anonymous)
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.auto_detail, formData)
        },

        inspector_detail(
            identifier,
            anonymous = false
        ) {
            var formData = new FormData()
            if (identifier) {
                appendFormData(formData, "inspector_id", identifier)
            }

            if (anonymous) {
                appendFormData(formData, "anonymous", anonymous)
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.inspector_detail, formData)
        },

        menu_detail(
            identifier,
            anonymous = false
        ) {
            var formData = new FormData()
            if (identifier) {
                appendFormData(formData, "menu_id", identifier)
            }

            if (anonymous) {
                appendFormData(formData, "anonymous", anonymous)
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.menu_detail, formData)
        },

        group_object_detail(
            order_id,
            group_id,
            anonymous = false
        ) {
            var formData = new FormData()
            if (order_id) {
                appendFormData(formData, "order_id", order_id)
            }
            if (group_id) {
                appendFormData(formData, "group_id", group_id)
            }
            if (anonymous) {
                appendFormData(formData, "anonymous", anonymous)
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.group_object_detail, formData)
        },

        report_detail(
            report_id,
            anonymous = false
        ) {
            var formData = new FormData()
            if (report_id) {
                appendFormData(formData, "report_id", report_id)
            }
            if (anonymous) {
                appendFormData(formData, "anonymous", anonymous)
            }

            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.order.report_detail, formData)
        },
    },
    detect_object: {
        update_detect_group_object(order, group_object, group, menu_id, fileUploadArguments, textArgument, test_result) {
            var formData = new FormData()
            var body = {}
            if (order) {
                appendFormData(formData, "order_id", order.identifier)
                if (group_object) {
                    appendFormData(formData, "group_object_id", group_object.identifier)
                }

                if (menu_id) {
                    appendFormData(formData, "menu_id", menu_id)
                }
                console.log(typeof(fileUploadArguments))
                console.log(fileUploadArguments)
                if (fileUploadArguments && fileUploadArguments instanceof Object && Object.keys(fileUploadArguments).length > 0) {
                    for (var key of Object.keys(fileUploadArguments)) {
                        var fileArgument = fileUploadArguments[key]
                        if (fileArgument) {
                            for (var file_dict of fileArgument.fileList) {
                                var fileObj = file_dict.originFileObj
                                var index = fileArgument.fileList.indexOf(file_dict)
                                
                                // 安卓环境下的文件对象处理优化
                                if (!fileObj && file_dict.url && typeof file_dict.url === 'string' && !file_dict.url.startsWith('http')) {
                                    // 如果url不是http链接，可能是base64或blob，跳过处理
                                    continue;
                                }
                                
                                if (!fileObj) {
                                    fileObj = file_dict.url
                                }
                                
                                // 确保文件对象有效
                                if (fileObj && (fileObj instanceof File || fileObj instanceof Blob || typeof fileObj === 'string')) {
                                    appendFormData(formData, String(key) + "_" + String(index), fileObj)
                                }
                            }
                        }

                    }
                    console.log(fileUploadArguments)
                }
            }
            if (test_result) {
                appendFormData(formData, "test_result", test_result)
            }
            if (group) {
                body["group"] = group
            }
            if (textArgument) {
                body['text'] = textArgument
            }
            if (body) {
                appendFormData(formData, "body", JSON.stringify(body))
            }
           
            console.log(body)
            appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            return axios_instance.post(urls.detect_object.update_detect_group_object, formData)
        }
    },
    search: {
        search(
            page,
            page_count,
            keyword,
            mode
        ) {
            var formData = new FormData()
            if (page) {
                appendFormData(formData, "page", page)
            }
            if (page_count) {
                appendFormData(formData, "page_count", page_count)
            }
            if (keyword) {
                appendFormData(formData, "keyword", keyword)
            }
            if (mode) {
                appendFormData(formData, "mode", mode)
            }
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.search.search, formData)
        }
    },
    company: {
        company() {
            var formData = new FormData()
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.company.index, formData)
        }
    },
    inspector: {
        list() {
            var formData = new FormData()
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.inspector.list, formData)
        }
    },
    wechat: {
        js_sdk_config(url) {
            var formData = new FormData()
            appendFormData(formData, "url", url)
            if (getCookie(xsrf_key)) {
                appendFormData(formData, xsrf_key, getCookie(xsrf_key))
            }
            return axios_instance.post(urls.wechat.js_sdk_params, formData)
        }
    }
}